/**
 * Inline option-value descriptions.
 *
 * Reads a value -> description map from each option fieldset's
 * `data-option-descriptions` attribute (built in snippets/product-option.liquid
 * from the `custom.option_value_descriptions` product metafield) and renders the
 * description of the currently selected value inline after the option label,
 * e.g.  "Infusion: Lavender - Helps Promote Relaxation".
 *
 * Uses event delegation + the theme's `product:variant-change` event so it keeps
 * working even when the variant picker re-renders its markup on selection.
 */
(function () {
  function getSelectedValue(fieldset) {
    var select = fieldset.querySelector('select');
    if (select) return select.value;
    var checked = fieldset.querySelector('input[type="radio"]:checked, input:checked');
    return checked ? checked.value : null;
  }

  function update(fieldset) {
    var target = fieldset.querySelector('.form__label__desc');
    if (!target) return;

    var map;
    try {
      map = JSON.parse(fieldset.getAttribute('data-option-descriptions'));
    } catch (e) {
      return;
    }

    var value = getSelectedValue(fieldset);
    var desc = value && map ? map[value] : null;
    target.textContent = desc ? ' - ' + desc : '';
  }

  function updateAll() {
    document.querySelectorAll('[data-option-descriptions]').forEach(update);
  }

  // Delegated change handler — survives the picker re-rendering its DOM.
  document.addEventListener('change', function (event) {
    var fieldset = event.target.closest && event.target.closest('[data-option-descriptions]');
    if (fieldset) update(fieldset);
  });

  // The theme fires this after it resolves the new variant (and may re-render labels).
  document.addEventListener('product:variant-change', updateAll);

  if (document.readyState !== 'loading') {
    updateAll();
  } else {
    document.addEventListener('DOMContentLoaded', updateAll);
  }
})();
